import React, { useEffect } from 'react';

/**
 * Minimal centered modal shell used by the shopper payout flow.
 */
const Modal = ({ isOpen, onClose, children, maxWidthClass = 'max-w-lg' }) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = event => {
      if (event.key === 'Escape' && onClose) onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center p-4'>
      <div
        className='absolute inset-0 bg-gray-900 bg-opacity-50'
        onClick={onClose}
        aria-hidden='true'
      />
      <div
        role='dialog'
        aria-modal='true'
        className={`relative bg-white rounded-lg shadow-xl w-full ${maxWidthClass}`}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
